// extracted by mini-css-extract-plugin
module.exports = {"wrap":"style_wrap__VBo_U","title":"style_title__OSTah","content":"style_content__LJoZ8"};